import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "Contact" }
const _hoisted_2 = { class: "TumiContainer" }
const _hoisted_3 = { class: "row text-center pt-5 pb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5 mb-3" }, "WHY CONTACT US?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-start" }, " Because calling us and having a short discussion is totally free, you can't lose. In fact, you automatically win. The worst that could happen is that you'll have to drink a good cup of coffee, hear some jokes and leave with new perspectives and ideas on how to maximize the potential of your business. ", -1)
const _hoisted_6 = { class: "bg-white p-5 text-start TumiContact" }
const _hoisted_7 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "TumiThanks mt-3 pt-1 pb-1 bg-succes text-center rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicPage = _resolveComponent("DynamicPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.activeObject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.activeObject)
            ? (_openBlock(), _createBlock(_component_DynamicPage, {
                key: 1,
                objet: _ctx.activeObject,
                validate: _ctx.error,
                onAction: _ctx.Save
              }, null, 8, ["objet", "validate", "onAction"]))
            : _createCommentVNode("", true),
          (_ctx.pass)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Thank you! "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}